module.exports = __webpack_public_path__ + "img/dollar.46243491.svg";